<template>
	<page>
		<module title="表单组件">
			<c-form ref="form">
				<c-form title="表单组件:">
					<c-form-column>
						<c-form-item type="input" label="文本框" name="input" required word="请填写内容"></c-form-item>
						<c-form-item type="textarea" label="文本域" name="textarea"></c-form-item>
						<c-form-item type="radio" label="单选框" name="radio" :options="options" :value="2" word="123"></c-form-item>
						<c-form-item type="checkbox" label="复选框" name="checkbox" :options="options" value="1" word="123"></c-form-item>
						<c-form-item type="select" label="下拉框" name="select" :options="options" value="3"></c-form-item>
						<c-form-item type="datetime" label="日期" name="datetime" date-type="date" value="1999-03-02"></c-form-item>
						<c-form-item type="datetime" label="日期范围" start-name="start-datetime" end-name="end-datetime" :value="['1999-03-02 00:00:00', '1999-03-04 00:00:00']" word="123"></c-form-item>
						<c-form-item type="color" label="颜色" name="color" word="123"></c-form-item>
						<c-form-item type="link" label="跳转链接" name="link"></c-form-item>
					</c-form-column>
					
					<c-form-column>
						<c-form-item type="image" label="上传图片" name="image" limit="3" required gallery file-word="图片尺寸建议800X800，格式支持jpg、png、gif，<br>文字信息需要在手机端能够看清楚；"></c-form-item>
						<c-form-item type="video" label="上传视频" name="video" gallery word="123"></c-form-item>
						<c-form-item type="file" label="上传文件" name="file" value="http://placehold.it/750x750/666/fff.png" file-word="格式支持doc、txt、rar、zip等等"></c-form-item>
						<c-form-item type="editor" label="编辑器" name="editor"></c-form-item>
						<c-form-item label="自定义">
							自定义自定义自定义自定义自定义自定义
						</c-form-item>
					</c-form-column>
				</c-form>
			</c-form>
			
			<template slot="button">
				<c-button size="m" @click="submit">提交发布</c-button>
				<c-button size="m" hollow>暂存草稿</c-button>
			</template>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'formName',
		
		data() {
			return {
				options: [{
					name: '选项一',
					value: 1
				}, {
					name: '选项二',
					value: 2
				}, {
					name: '选项三',
					value: 3
				}]
			}
		},
		
		created() {
			// console.log('created')
		},
		
		mounted() {
			// console.log('mounted')
		},
		
		activated() {
			// console.log('activated')
		},
		
		deactivated() {
			// console.log('deactivated')
		},
		
		destroyed() {
			// console.log('destroyed')
		},
		
		methods: {
			submit() {
				console.log(this.$refs.form.serialize());
				this.$refs.form.submit({
					rule: {
						input: [{
							type: 'empty',
							word: '请填写原密码'
						}]
					},
					
					success: (data, param) => {
						console.log(data);
					}
				});
			}
		}
	}
</script>

<style scoped>
</style>